// Banner.js
import React, { useState, useEffect, useRef } from "react";
import "./Banner.css"; 

import { Link } from "react-router-dom";

const images = [
  "images/banners/slide_1.jpg", 
  "images/banners/slide_2.jpg",
  "images/banners/slide_3.jpg", 
  "images/banners/slide_4.jpg",
  "images/banners/slide_5.jpg", 
  "images/banners/slide_6.jpg",
];

const Banner = () => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [inView, setInView] = useState(false);

  const welcomeTextRef = useRef(null); 

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // Change image every 5 seconds
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      if (welcomeTextRef.current) {
        const rect = welcomeTextRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          setInView(true);
        } else {
          setInView(false);
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [welcomeTextRef]); 

    useEffect(() => {
      var text = document.getElementById('text');
      var newDom = '';
      var animationDelay = 6;
  
      for(let i = 0; i < text.innerText.length; i++) {
        newDom += '<span class="char2">' + (text.innerText[i] === ' ' ? '&nbsp;' : text.innerText[i]) + '</span>';
      }
  
      text.innerHTML = newDom;
      var length = text.children.length;
  
      for(let i = 0; i < length; i++) {
        text.children[i].style['animation-delay'] = animationDelay * i + 'ms';
      }
    }, []);

  return (
    <div
      className="banner"
      style={{
        backgroundImage: `url(${images[currentImageIndex]})`,
      }}
    >
      <div className="banner-overlay">
        <div className="banner-content">
          <div className="container">
            <div className="carousel-caption caption-1">
              <div
                className="welcome-text"
              >
                <div className="top-line"></div>
                <h5>
                <span class="open-text">
                      <span className="welcome-to">
                      <span class="block span1"></span>
                      <span className="welcome">Welcome to</span>
                      </span>
                </span>

                  <br></br>
                  <span className="animate one">
                    <span>A</span><span>c</span><span>t</span><span>u</span><span>a</span><span>r</span>
                    <span>i</span><span>a</span><span>l</span><span>&nbsp;</span><span>s</span><span>o</span>
                    <span>c</span><span>i</span><span>e</span><span>t</span>
                    <span>y</span><span>&nbsp;</span><span>o</span><span>f</span><span>&nbsp;</span>
                    <span>G</span><span>h</span><span>a</span><span>n</span><span>a</span>
                  </span>
                </h5>
                <div className="bottom-line"></div>
              </div>
            </div>
          </div>
          <div className="B-paragraph">
              <p className="paragraph"  id="text">
              The ASG aims to promote and regluate the practice
              of the actuarial profession in Ghana.
              </p>
          </div>
          <div className={`banner-buttons animate-up ${
                  inView ? "in-view" : ""
                }`}
                ref={welcomeTextRef}>
            <Link to="/LatestNews_1" className="btn btn-primary">
              Discover the latest actuarial news
            </Link>
            <Link to="/jobs" className="btn btn-secondary">
              Explore our actuarial job pages
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Banner;
